function input(el) {
  el.value = el.value.replace(/。/g, ".");
  el.value = el.value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
  el.value = el.value.replace(/^\./g, ""); //验证第一个字符是数字
  el.value = el.value.replace(/^0+(\d)/, "$1"); //第一位0开头，0后面为数字，则过滤掉，取后面的数字
  el.value = el.value.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
  el.value = el.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  el.value = el.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
}

function blur(el) {
  if (!Number(el.value)) return; //没有值不处理
  el.value = Number(el.value).toFixed(2); //除了0其他自动补全0
}

export default {
  bind: function (el, binding, vnode) {
    el = el.querySelector('.el-input__inner') || el.querySelector('.el-textarea__inner') || el;
    let lock = false // 标记是否需要锁定输入框
    let isHandling = false // 标记是否正在处理
    let lastValue = null
    var inputHandler = () => {
      if (lock) return // 如果当前为锁定状态，则不进行处理
      if (isHandling) return // 如果已经在处理中，则不进行处理
      if (el.value === lastValue) return // 输入内容没有变化，则不进行处理
      isHandling = true // 设置标记为处理中
      lastValue = el.value // 记录当前输入框的值
      input(el, binding.value);
      Promise.resolve().then(() => {
        // 异步处理，场景：火狐浏览器中，需要在最后派发input事件
        el.dispatchEvent(new Event('input'))
      })
      isHandling = false // 处理完毕后设置标记为非处理状态
    }
    let lockBlur = false // 标记是否需要锁定输入框
    let isHandlingBlur = false // 标记是否正在处理
    let lastValueBlur = null
    var blurHandler = () => {
      if (lockBlur) return // 如果当前为锁定状态，则不进行处理
      if (isHandlingBlur) return // 如果已经在处理中，则不进行处理
      if (el.value === lastValueBlur) return // 输入内容没有变化，则不进行处理
      isHandlingBlur = true // 设置标记为处理中
      lastValueBlur = el.value // 记录当前输入框的值
      blur(el, binding.value);
      Promise.resolve().then(() => {
        // 异步处理，场景：火狐浏览器中，需要在最后派发input事件
        var event;
        if (typeof (Event) === 'function') {
          event = new Event('blur');
        } else {
          event = document.createEvent('Event');
          event.initEvent('blur', false, true);
        }
        el.dispatchEvent(event)
      })
      isHandlingBlur = false // 处理完毕后设置标记为非处理状态
    }
    el.addEventListener('input', inputHandler)
    el.addEventListener('blur', blurHandler)
    el.addEventListener('compositionstart', () => {
      lock = true
    })
    el.addEventListener('compositionend', () => {
      lock = false
      var blurEvent;
      var inputEvent;
      if (typeof (Event) === 'function') {
        blurEvent = new Event('blur');
        inputEvent = new Event('input');
      } else {
        blurEvent = document.createEvent('Event');
        inputEvent = document.createEvent('Event');
        blurEvent.initEvent('blur', false, true);
        inputEvent.initEvent('input', false, true);
      }
      el.dispatchEvent(inputEvent)
      el.dispatchEvent(blurEvent)
    })
    // 当指令与元素解绑时，移除事件监听器
    vnode.context.$once('hook:destroyed', () => {
      el.removeEventListener('input', inputHandler)
      el.removeEventListener('blur', blurHandler)
    })
  }
}